import { axiosService } from '..';

export default class UnpublishBusinessFrontPageService {
    public async execute(businessId: number): Promise<UnpublishBusinessFrontPageServiceOutputDto> {
        const response = await axiosService.instance.post(`businesses/organization/front-page/${businessId}/unpublish`);
        return new UnpublishBusinessFrontPageServiceOutputDto(response.data.result, response.data.hasPublishedFrontPage, response.data.hasPublishedReferences);
    }
}

export class UnpublishBusinessFrontPageServiceOutputDto {
    public readonly result: boolean;
    public readonly hasPublishedFrontPage: boolean | null;
    public readonly hasPublishedReferences: boolean | null;

    constructor(result: boolean, hasPublishedFrontPage: boolean | null, hasPublishedReferences: boolean | null) {
        this.result = result;
        this.hasPublishedFrontPage = hasPublishedFrontPage;
        this.hasPublishedReferences = hasPublishedReferences;
    }
}

export const unpublishBusinessFrontPageService = new UnpublishBusinessFrontPageService();
